declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';

declare var require: any;

import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { NgbAddVendorModal } from './modal/addvendor.modal';
import { NgbEditVendorModal } from './modal/editvendor.modal';
import { NgbAddCredentialsModal } from './modal/addcredentials.modal';
import { NgbEditCredentialsModal } from './modal/editcredentials.modal';
import { NgbAddsuplMaterialsModal } from './modal/addsuplmaterials.modal';
import { NgbEditsuplMaterialsModal } from './modal/editsuplmaterials.modal';
import { SaveVendorInformationRequest, VendorsListController, VendorsListRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { NgxSpinnerService } from 'ngx-spinner';
import { NGXToastrService } from '../../../../../../src/app/shared/services/toastr.service';





@Component({
  selector: 'vendors',
  templateUrl: './vendors.component.html',
  styleUrls: [
    './vendors.component.scss']
  , animations: [routerTransition()]
})

export class VendorsComponent implements OnInit {

  public ShowList: boolean = true;
  public AddVendor: boolean = false;
  public EditVendor: boolean = false;
  public isRequesting: boolean = false;

  CurrentSaveVendorInformationRequest: SaveVendorInformationRequest;
  public ApiResData: ApiResponseModel;

  constructor(private router: Router,
    private spinner: NgxSpinnerService,
    private tosterservice: NGXToastrService,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService) { }

  ngOnInit() {

    this.LoadVendors();
    this.CurrentSaveVendorInformationRequest = new SaveVendorInformationRequest();
    this.CurrentSaveVendorInformationRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

  }

  AddNewVendor() {
    this.ShowList = false;
    this.AddVendor = true;
    this.EditVendor = false;
  }
  EditVend() {
    this.ShowList = false;
    this.AddVendor = false;
    this.EditVendor = true;
  }
  Cancel() {
    this.ShowList = true;
    this.AddVendor = false;
    this.EditVendor = false;
  }

  //AddNewVendor() {

  //  const modalRef = this.modalService.open(NgbAddVendorModal,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })

  //}

  //EditVendor() {

  //  const modalRef = this.modalService.open(NgbEditVendorModal,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })

  //}

  AddNewCredential() {

    const modalRef = this.modalService.open(NgbAddCredentialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  EditNewCredential() {

    const modalRef = this.modalService.open(NgbEditCredentialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  AddNewsuplMaterials() {

    const modalRef = this.modalService.open(NgbAddsuplMaterialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  EditNewsuplMaterials() {

    const modalRef = this.modalService.open(NgbEditsuplMaterialsModal,
      {
        centered: true,
        size: "lg",
        backdrop: 'static',
        keyboard: false
      })

  }

  CurrentVendorsListController: VendorsListController;
  CurrentVendorsListRequest: VendorsListRequest;
  LoadVendors() {
    this.CurrentVendorsListRequest = new VendorsListRequest();
    this.CurrentVendorsListRequest.ConditionalOperator = 10;
    this.CurrentVendorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetVendorsListController();
  }
  GetVendorsListController() {
    this.StartRefreshing();
    //this.spinner.show();

    this.actorservice.GetVendorsListController(this.CurrentVendorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentCounsellingActivitiesByTimeController = this.ApiResData.Result;
          //this.RefreshPatientsByDate();
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  onSubmit() {

    this.spinner.show();
    this.CurrentSaveVendorInformationRequest.ConditionalOperator = 1;
    this.CurrentSaveVendorInformationRequest.VendorActorCode = 0;
    this.CurrentSaveVendorInformationRequest.VendorMasterCode = 0;
    this.CurrentSaveVendorInformationRequest.ActorType = 4;
    this.CurrentSaveVendorInformationRequest.VendorSalutaion = "Mr";
    this.actorservice.SaveVendorInformation(this.CurrentSaveVendorInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          //this.activeModal.close();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );



  }

  onSubmit2() {

    this.spinner.show();
    this.CurrentSaveVendorInformationRequest.ConditionalOperator = 2;
    this.CurrentSaveVendorInformationRequest.VendorAddressCode = 0;
    this.CurrentSaveVendorInformationRequest.VendorActorCode = 44133;
    //this.CurrentSaveVendorInformationRequest.ActorType = 4;
    //this.CurrentSaveVendorInformationRequest.VendorSalutaion = "Mr";
    this.actorservice.SaveVendorInformation(this.CurrentSaveVendorInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          //this.activeModal.close();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );



  }

  onSubmit3() {

    this.spinner.show();
    this.CurrentSaveVendorInformationRequest.ConditionalOperator = 3;
    this.CurrentSaveVendorInformationRequest.VendorAddressCode = 57640;
    this.CurrentSaveVendorInformationRequest.VendorActorCode = 44133;
    //this.CurrentSaveVendorInformationRequest.ActorType = 4;
    //this.CurrentSaveVendorInformationRequest.VendorSalutaion = "Mr";
    this.actorservice.SaveVendorInformation(this.CurrentSaveVendorInformationRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          //this.activeModal.close();
          this.spinner.hide();
        }
        else {
          this.stopRefreshing();
          this.spinner.hide();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);



          }
          else {
            this.stopRefreshing();
            this.spinner.hide();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');

          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );



  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



}
